<template>
  <div
    v-if="visible"
    :class="[
      bemBlockMod({
        [type]: type,
        'is-invalid': isInvalid,
      }),
      'form__field',
      'form-group',
      alwaysFloatingLabel
        ? 'interaction--always-floating-label'
        : 'interaction--floating-label',
    ]"
  >
    <input
      :id="id"
      ref="input"
      :aria-required="required.toString()"
      :autocomplete="autocomplete"
      :class="[
        bemElement('input'),
        'input',
        `input--${type}`,
        classInput,
        'form-control',
        { 'is-invalid': isInvalid },
      ]"
      :disabled="disabled"
      :readonly="readonly"
      :name="name"
      :min="min"
      :max="max"
      :maxlength="maxlength > 0 ? maxlength : ''"
      :minlength="minlength > 0 ? minlength : ''"
      :pattern="pattern"
      :placeholder="placeholder"
      :required="required"
      :type="inputType"
      :value="value"
      :data-pattern-mismatch="errorMessages.patternMismatch"
      :data-range-error="errorMessages.rangeError"
      :data-missing-error="dataMissingError || errorMessages.missingError"
      v-on="inputListeners"
      @invalid="handleInvalid"
    />
    <label
      v-if="!hideLabel"
      :class="[bemElement('label'), classLabel]"
      :for="id"
    >
      {{ label }}
    </label>
    <div :class="[bemElement('error-message'), 'invalid-feedback']">
      {{ errorMessage }}
    </div>
    <p v-if="helpText" class="form__message">
      {{ helpText }}
    </p>
  </div>
</template>

<script>
import bemClassesMixin from '../../mixins/bemClassesMixin';
import mixinField from './mixinField';
import mixinValidation from './mixinValidation';

export default {
  name: 'FieldText',

  mixins: [bemClassesMixin, mixinField, mixinValidation],

  props: {
    autocomplete: {
      type: String,
      default: '',
      validator(value) {
        return ['', 'on', 'off'].indexOf(value) !== -1;
      },
    },

    helpText: {
      type: String,
      default: '',
    },

    hideLabel: {
      type: Boolean,
      default: false,
    },

    inputType: {
      type: String,
      default: 'text',
      validator(value) {
        return (
          [
            'date',
            'datetime',
            'datetime-local',
            'email',
            'month',
            'number',
            'search',
            'tel',
            'text',
            'time',
            'url',
            'week',
          ].indexOf(value) !== -1
        );
      },
    },

    label: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: null,
    },

    dataMissingError: {
      type: String,
      default: undefined,
    },

    min: {
      type: String,
      default: '',
    },

    max: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: 'primary',
      validator(value) {
        return ['primary', 'secondary'].indexOf(value) !== -1;
      },
    },

    errorMessages: {
      type: Object,
      default: () => ({
        missingError: undefined,
        patternMismatch: undefined,
        rangeError: undefined,
      }),
    },

    pattern: {
      type: String,
      default: null,
    },
    alwaysFloatingLabel: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      errorMessage: undefined,
      isInvalid: false,
    };
  },

  computed: {
    inputListeners() {
      const vm = this;
      return {
        // We add all the listeners from the parent
        ...this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        ...{
          // This ensures that the component works with v-model
          input(event) {
            vm.$emit('input', event.target.value);
          },
        },
      };
    },
  },

  methods: {
    focus() {
      this.$refs.input.focus();
    },
    blur() {
      this.$refs.input.blur();
    },
  },
};
</script>
